<div class="text-center">
    <p class="text-4xl">
        {{errorText}}
    </p>
</div>